module.exports = __webpack_public_path__ + "static/media/slack.32f4962e.svg";